<script>
	import { Link } from 'svelte-routing';
	import FeaturedProducts from '../lib/components/FeaturedProducts.svelte';
	import HeroSlider from '../lib/components/HeroSlider.svelte';
	import NewArrival from '../lib/components/NewArrival.svelte';
</script>

<!-- herosection -->
<HeroSlider />
<!-- Categories Section -->
<section class="section category">
	<div class="cat-center">
		<Link to="/products" class="cat">
			<img src="/images/products/p-10.jpg" alt="" />
			<div>
				<p>SKATEBOARD'S</p>
			</div>
		</Link>
		<Link to="/products" class="cat">
			<img src="/images/products/p-21.jpg" alt="" />
			<div>
				<p>SHOE'S</p>
			</div>
		</Link>
		<Link to="/products" class="cat">
			<img src="/images/products/p-16.jpg" alt="" />
			<div>
				<p>OUTFITS'S</p>
			</div>
		</Link>
	</div>
</section>

<!-- New Arrivals -->
<NewArrival />

<!-- Promo -->

<section class="section banner">
	<div class="left">
		<span class="trend">TOP ITEMS</span>
		<h1>New Arrival <span style="color:orange">2023</span></h1>
		<p>
			New Arrival <span class="color">Sale 50% OFF</span> Limited Time Offer
		</p>
		<Link to="/products" class="btn btn-1">Discover Now</Link>
	</div>
	<div class="right">
		<img src="/images/featured-img.png" alt="" />
	</div>
</section>

<!-- Featured -->
<FeaturedProducts />

<!-- contact -->

<section class="section contact">
	<div class="row">
		<div class="col">
			<h2>EXCELLENT SUPPORT</h2>
			<p>
				We love our customers and they can reach us any time of day we will be
				at your service 24/7
			</p>
			<a href="" class="btn btn-1">Contact</a>
		</div>
		<div class="col">
			<form action="">
				<div>
					<input type="email" placeholder="Email Address" />
					<a href="">Send</a>
				</div>
			</form>
		</div>
	</div>
</section>
